<div [ngClass]="{'attachment-container': !sideDrawerConfiguration}">
  <h2
    *ngIf="!sideDrawerConfiguration"
    class="attachments-header"
  >Files and attachments</h2>
  <ng-container
    *ngIf="(resumesLoaded$ | async) && (othersLoaded$ | async); else loader"
  >
    <ng-container *mojoHasPrivilege="privileges.candidates.resumes">
      <mojo-attachments-list
        [attachments]="resumes$ | async"
        [emptyMessage]="emptyMessage"
        title="Resume"
        (delete)="delete($event)"
        (upload)="uploadResume()"
      >
      </mojo-attachments-list>
    </ng-container>
    <ng-container *mojoHasPrivilege="privileges.candidates.filesReadOnly">
      <mojo-attachments-list
        [attachments]="resumes$ | async"
        [emptyMessage]="emptyMessage"
        title="Resume"
      >
      </mojo-attachments-list>
    </ng-container>
    <ng-container *mojoHasFeatureExtension="coverLetterFE">
      <div *ngIf="(coverLetters$ | async)?.length > 0">
        <mojo-attachments-list
          [attachments]="coverLetters$ | async"
          title="Cover letter"
        >
        </mojo-attachments-list>
      </div>
    </ng-container>
    <ng-container *mojoHasPrivilege="privileges.candidates.files">
      <mojo-attachments-list
        [attachments]="others$ | async"
        [emptyMessage]="emptyMessage"
        title="Other files"
        (delete)="delete($event)"
        (upload)="uploadOther()"
      >
      </mojo-attachments-list>
    </ng-container>
  </ng-container>

  <ng-template #loader>
    <mojo-loader></mojo-loader>
  </ng-template>
</div>
